interface iCateNode{
    id: string;
    title: string;
    children?: iCateNode[];
}

//actions type
const SET_CATE_TREE = 'SET_CATE_TREE';

export type { iCateNode };
export { SET_CATE_TREE };
